<template>
  <master-main
    :route="getModuleRoute"
    :addProperties="{
      eventType: 1,
      routeToCreate: getModuleRoute,
    }"
    :tableProperties="tableProperties"
    :exportProperties="{
      pdf: {
        filename: `${$t('common_words.crops')}.pdf`,
        route: `${getModuleRoute}/pdf`,
      },
      xls: {
        filename: `${$t('common_words.crops')}.xlsx`,
        route: `${getModuleRoute}/excel`,
      },
    }"
    :dataBadges="[
      {
        columnLabel: $t('common_words.companies'),
        data: 'businesses',
        property: 'name',
        minWidth: 110,
      },
    ]"
    @showHideLoading="showHideLoading"
    @showNotification="notifyVue"
    @refresh="refresh"
  ></master-main>
</template>
<script>
import CropTable from './crop-table';
import i18n from 'src/i18n';
import MasterMain from 'src/components/Layouts/Masters/MasterMain.vue';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMain from 'src/mixins/master/mixin-main';
import MixinPermissions from 'src/util/mixinPermissions';

export default {
  components: { MasterMain },
  data() {
    return {
      tableProperties: {},
    };
  },
  computed: {
    getModuleRoute() {
      return 'farms/crops';
    },
    buildTableProperties() {
      return {
        tableColumns: [...CropTable().tableColumns],
        effectTags: 'dark',
        model: 'crop',
        addColumns: [
          {
            data: 'crop_varieties',
            label: i18n.t('common_words.varieties'),
            field: 'name',
          },
        ],
      };
    },
  },
  mixins: [MixinAlert, MixinLoading, MixinMain, MixinPermissions],
};
</script>
